import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { convertNumberIntoLakhsAndCroreWithSign } from "../../../../utils/methods";
import styles from "./call-oi-box.module.scss";
const CallOiBox = (props) => {
    const { oi = 0, oiPerc = "0" } = props;
    // const getOIText = (oi: number): string => {
    //   let newOI = "";
    //   if (oi > 1000) {
    //     newOI = `${(oi / 100000).toFixed(2)} L`;
    //   } else {
    //     return `${oi}`;
    //   }
    //   return newOI;
    // };
    return (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: `${styles.number} mediumWeight medium` }, { children: convertNumberIntoLakhsAndCroreWithSign(oi) })), _jsx("span", Object.assign({ className: `${styles.perc} mediumWeight small` }, { children: `${convertNumberIntoLakhsAndCroreWithSign(Number(oiPerc))}` }))] }));
};
export default memo(CallOiBox);
